import { activeParentStatuses } from '@store/models/const';
import { SubscriptionStatusChildEnum } from '../types';
export const checkChildUserCanceled = ({ parentStatus, childStatus, isChildUser, }) => {
    const isParentActive = !!parentStatus && activeParentStatuses.includes(parentStatus);
    return isParentActive && isChildUser && childStatus === SubscriptionStatusChildEnum.Canceled;
};
